import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {unwrapResult} from '@reduxjs/toolkit'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import CircularProgressAtom from '../../@atoms/to_forms/circular_progress/circular_progress.atom'
import DateSelectionActionBtnWrapperAtom from '../../@atoms/to_content/date_selection_action_btn_wrapper/date_selection_action_btn_wrapper.atom'
import visitService from '../../services/visit.service'
import {RootState, Dispatch} from '../../store_redux'
import {BookVisitDatePayload, Visit} from '../../props_reusable/visit'
import {
  hideModal,
  showSpecialInstructionModal,
} from '../../store_redux/reducer/modal.reducer'
import {fetchAllVisits} from '../../store_redux/reducer/order_details.reducer'
import utils from '../../utils'

interface DateSelectionActionBtnComponentProps {
  btnDisabled?: boolean
  setError: (arg1: string, arg2: string) => void
  getBookVisitPayload: () => BookVisitDatePayload
}

const DateSelectionActionBtnComponent: React.FC<DateSelectionActionBtnComponentProps> =
  function ({btnDisabled, setError, getBookVisitPayload}) {
    const [loading, setLoading] = useState(false)
    const rootState = useSelector((state: RootState) => state)
    const dispatch = useDispatch<Dispatch>()
    const {settings, labels} = rootState

    if (utils.isObjectEmpty(labels)) return null
    const {buttonCancel, buttonFormSubmit} = labels.bookDateModal

    const closeModal = () => {
      dispatch(hideModal())
    }

    const handleBookVisitError = (err: Error) => {
      setError('bookDate', err.message)
    }

    const routeToSpecialInstruction = (visits: Visit[]) => {
      if (
        settings.isInstructionAllowed &&
        Array.isArray(visits) &&
        visits.length === 1
      ) {
        const visitData = visits[0]
        if (visitData)
          dispatch(
            showSpecialInstructionModal({
              type: visitData.specialInstructions ? 'EDIT' : 'ADD',
              content: visitData.specialInstructions || '',
              redirectedFrom: 'DATE_SCREEN',
              visitId: visitData.visitNumber,
            }),
          )
        else dispatch(hideModal())
      } else dispatch(hideModal())
    }

    const handleBookVisit = () => {
      if (!btnDisabled) {
        setLoading(true)
        const payload = getBookVisitPayload()
        visitService
          .bookDate(payload)
          .then(() => dispatch(fetchAllVisits()))
          .then(unwrapResult)
          .then(routeToSpecialInstruction)
          .catch(handleBookVisitError)
      }
    }

    return (
      <DateSelectionActionBtnWrapperAtom>
        <BoxAtom>
          <ButtonAtom ap_type="secondary" fullWidth onClick={closeModal}>
            {buttonCancel}
          </ButtonAtom>
        </BoxAtom>
        <BoxAtom
          className={utils.classnames({
            'cursor-not-allowed': loading,
          })}
        >
          <ButtonAtom
            ap_type="primary"
            fullWidth
            disabled={btnDisabled}
            className={utils.classnames({
              'btn-disabled': loading,
            })}
            onClick={handleBookVisit}
          >
            {loading ? (
              <CircularProgressAtom size="1.5rem" ap_type="btn_spinner" />
            ) : (
              buttonFormSubmit
            )}
          </ButtonAtom>
        </BoxAtom>
      </DateSelectionActionBtnWrapperAtom>
    )
  }

DateSelectionActionBtnComponent.defaultProps = {
  btnDisabled: false,
}

export default DateSelectionActionBtnComponent
